import { useMemo } from 'react';

import type { PresetKidMarkersContext } from '../../../hooks/usePresetKidMarkers';
import { usePresetKidMarkers } from '../../../hooks/usePresetKidMarkers';
import { buildSriValueFromMarkers } from './buildTablesFromMarkers';
import { usePresetSriInjection } from './usePresetTableInjection';

/**
 * Seed hook for the SRI chart block: same marker path as set tables
 * (`usePresetKidMarkers` + override), then sync FIG:sri onto the form.
 */
export function useSeededSri(
  index: number,
  markerContext?: PresetKidMarkersContext,
) {
  const { markers, isLoading } = usePresetKidMarkers(
    markerContext ?? {},
    'figure',
  );

  const sriValue = useMemo(
    () => buildSriValueFromMarkers(markers),
    [markers],
  );

  usePresetSriInjection(index, markers, sriValue);

  return {
    sriValue,
    isLoading,
    hasMarkers: markers.length > 0 && sriValue != null,
  };
}
